module.exports = __webpack_public_path__ + "media/tags/early-game-4d3489f9.png";